export default "__VITE_ASSET__BZ4u2RuP__"